import { render, staticRenderFns } from "./DescuentosComercio.vue?vue&type=template&id=0a8d92ac&scoped=true&"
import script from "./DescuentosComercio.vue?vue&type=script&lang=js&"
export * from "./DescuentosComercio.vue?vue&type=script&lang=js&"
import style0 from "./DescuentosComercio.vue?vue&type=style&index=0&id=0a8d92ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8d92ac",
  null
  
)

export default component.exports